module.exports = __webpack_public_path__ + "img/guofen.69260a52.png";